module.exports = __webpack_public_path__ + "img/login.b9a41a25.jpg";